import React, { useState, useRef, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid'
import PropTypes from 'prop-types';
import axios from 'src/utils/axios';
import mgmtCustomerForm from "src/services/mgmtCustomerForm";
import PersonIcon from '@mui/icons-material/Person';
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import ModeIcon from '@mui/icons-material/Mode';
import Tooltip from '@mui/material/Tooltip';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SecurityUpdateIcon from '@mui/icons-material/SecurityUpdate';
import DownloadIcon from '@mui/icons-material/Download';
import UpdateIcon from '@mui/icons-material/Update';
import { BrowserQRCodeReader } from '@zxing/browser';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import DialogTitle from "@mui/material/DialogTitle";

import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
//  <UpdateIcon />
import PaymentIcon from '@mui/icons-material/Payment';
import {
  Dialog,
  DialogContent,
  DialogActions
} from "@mui/material";

import {
  Box,
  IconButton,
  SvgIcon,
  Button,
} from '@mui/material';
import {
  Image as ImageIcon,
  Edit as EditIcon,
  ArrowRight as ArrowRightIcon,
  Search as SearchIcon
} from 'react-feather';

import QrCodeIcon from '@mui/icons-material/QrCode';
import { useSnackbar } from 'notistack';

function Results({ className, services, services1, setServices, path, customer, ...rest }) {

  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
    const handleQrClick = (customerId) => {
    setSelectedCustomerId(customerId);
    fileInputRef.current.click();
  };

  const { enqueueSnackbar } = useSnackbar();
  const [rows, setRows] = useState([]);
  const [previewImage, setPreviewImage] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isValidQR, setIsValidQR] = useState(false);
  const [openPreview, setOpenPreview] = useState(false);
  const [qrMessage, setQrMessage] = useState("");
  const [qrMessageType, setQrMessageType] = useState("");
  const [openApkDialog, setOpenApkDialog] = useState(false);
const [apkData, setApkData] = useState({
  customerId: "",
  isAndroid: false,
  isIos: false,
  isWebApp: false,
  isPosApp: false,
});

  useEffect(() => {
  if (customer === "ADMIN" || customer === "SUPPORT") {
    setRows(services1 || []);
  } else {
    setRows(services || []);
  }
}, [services, services1, customer]);



const handleQrUpload = (event) => {
  const file = event.target.files[0];
  if (!file) return;

  if (!file.type.startsWith("image/")) {
    setQrMessage("Please upload a valid image file");
    setQrMessageType("error");
    setIsValidQR(false);
    setPreviewImage(null);
    setOpenPreview(true);
    return;
  }

  const reader = new FileReader();
  reader.readAsDataURL(file);

  reader.onload = () => {
    const img = new Image();
    img.src = reader.result;

    img.onload = async () => {
      const codeReader = new BrowserQRCodeReader();

      try {
        await codeReader.decodeFromImageElement(img);
        setIsValidQR(true);
        setQrMessage("Valid QR Code");
        setQrMessageType("success");

      } catch (error) {
        setIsValidQR(false);
        setQrMessage("Invalid QR Code Image");
        setQrMessageType("error");
      }


      setSelectedFile(file);
      setPreviewImage(reader.result);
      setOpenPreview(true);
      event.target.value = null;
    };
  };
};



const handleFinalUpload = async () => {
  if (!isValidQR || !selectedFile) {
    enqueueSnackbar("Please upload a valid QR image", {
      variant: "error",
    });
    return;
  }

  const formData = new FormData();
  formData.append("qrImage", selectedFile);
  formData.append("customerId", selectedCustomerId);

  try {
    await axios.post(
      "/api/admin/customer/upload/qrcode",
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    enqueueSnackbar("QR Code uploaded successfully", {
      variant: "success",
    });

setOpenPreview(false);
setPreviewImage(null);
setSelectedFile(null);
setIsValidQR(false);

  } catch (error) {
    enqueueSnackbar("Upload failed", {
      variant: "error",
    });
  }
};


const handleNeighbourhoodUpdate = async (customerId, currentValue) => {
  try {
    await axios.post(
      '/api/admin/customer/manage/customer-details',
      {
        customerId,
        customerData: {
          isNeighbourhoodApp: !currentValue,
        },
      }
    );


    setRows((prevRows) =>
      prevRows.map((item) =>
        item.customerId === customerId
          ? { ...item, isNeighbourhoodApp: !currentValue }
          : item
      )
    );

    enqueueSnackbar(
      `Neighbourhood App ${!currentValue ? 'Enabled' : 'Disabled'} successfully`,
      { variant: 'success' }
    );

  } catch (error) {
    console.log("API ERROR:", error.response?.data || error.message);

    enqueueSnackbar('Failed to update Neighbourhood App', {
      variant: 'error',
    });
  }
};
const handleApkAvailability = async (row) => {
  try {
    const data = await mgmtCustomerForm.apkAvailability(row.customerId);

    setApkData({
      customerId: row.customerId,
      isAndroid: data.isAndroid,
      isIos: data.isIos,
      isWebApp: data.isWebApp,
      isPosApp: data.isPosApp
    });

    setOpenApkDialog(true);

  } catch (error) {


    setApkData({
      customerId: row.customerId,
      isAndroid: false,
      isIos: false,
      isWebApp: false,
      isPosApp: false
    });

    setOpenApkDialog(true);
  }
};
const handleApkSave = async () => {
    try {
        await mgmtCustomerForm.manageApkAvailability(apkData);
        enqueueSnackbar("APK Availability Updated", {
            variant: "success"
        });
        setOpenApkDialog(false);

    } catch (error) {
        enqueueSnackbar("Update Failed", {
            variant: "error"
        });

    }
};
const columns = [
    { field: 'customerId', headerName: 'CustomerId ', width: 100 },
    { field: 'businessName', headerName: 'BusinessName', width: 200 },
    { field: 'licenseExpiryDate', headerName: 'License Expiring Date', width: 220,
    renderCell: (params) => { return params.row?.license?.validtill ? new Date(params.row.license.validtill).toLocaleDateString(): 'N/A';
    },
  },

{
  field: 'isNeighbourhoodApp',
  headerName: 'Neighbourhood App',
  width: 260,
  renderCell: (params) => {
    const isEnabled = params.row.isNeighbourhoodApp;

    return (
     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Button
          size="small"
          variant="outlined"
          color={isEnabled ? 'success' : 'success'}
          onClick={() =>
            handleNeighbourhoodUpdate(
              params.row.customerId,
              isEnabled
            )
          }
        >
{isEnabled ? (
  <CheckCircleIcon color="success" />
) : (
  <TaskAltIcon color="success" />
)}
        </Button>
      </Box>
    );
  },
},
{
      field: "action",
      headerName: "Action",
      width: 480,
      renderCell: (params) => {
        const paymentType = params.row.paymentGateway
        const paymentTypeInfo = paymentType
        return (
          <div className="cellAction">

            <Tooltip title="Edit Logo And Banner">
              <IconButton
                onClick={() => {
                  navigate('/app/management/customer/update', { state: params.row });
                }
                }
              >
                <SvgIcon fontSize="small">
                  <ModeIcon />
                </SvgIcon>
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit Customer Brand Details">
              <IconButton
                onClick={() => {
                  navigate('/app/management/customer/info/update', { state: params.row });
                }
                }
              >
                <SvgIcon fontSize="small">
                  <EditIcon />
                </SvgIcon>
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit Privacy Policy">
              <IconButton
                onClick={() => {
                  navigate('/app/management/customer/privacypolicy/update', { state: params.row });
                }
                }
              >
                <SvgIcon fontSize="small">
                  <PrivacyTipIcon />
                </SvgIcon>
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit Customer Details">
              <IconButton
                onClick={() => {
                  navigate('/app/management/customer/customerdetails/update', { state: params.row });
                }
                }
              >
                <SvgIcon fontSize="small">
                  <PersonIcon />
                </SvgIcon>
              </IconButton>
            </Tooltip>
            <Tooltip title="Customer View">
              <IconButton
                onClick={() => {
                  navigate('/app/management/customer/info/view', { state: params.row });
                }
                }
              >
                <SvgIcon fontSize="small">
                  <VisibilityIcon />
                </SvgIcon>
              </IconButton>
            </Tooltip>
            <Tooltip title="Customer Json File Download">
              <IconButton
                onClick={() => {
                  navigate('/app/management/customer/json/download', { state: params.row.customerId });
                }
                }
              >
                <SvgIcon fontSize="small">
                  <DownloadIcon />
                </SvgIcon>
              </IconButton>
            </Tooltip>
            <Tooltip title="Update License">
              <IconButton
                onClick={() => {
                  navigate('/app/management/license/view', { state: params.row });
                }
                }
              >
                <SvgIcon fontSize="small">
                  <SecurityUpdateIcon />
                </SvgIcon>
              </IconButton>
            </Tooltip>
            <Tooltip title="Update Payment Credentials">
              <IconButton
                onClick={() => {
                  navigate('/app/management/update/payment/credentials', { state: params.row });
                }
                }
              >
                <SvgIcon fontSize="small">
                  <PaymentIcon/>
                </SvgIcon>
              </IconButton>
            </Tooltip>
            <Tooltip title="Delivery Charges">
              <IconButton
                onClick={() => {
                  navigate('/app/management/delivery/charges', { state: params.row });
                }
                }
              >
                <SvgIcon fontSize="small">
                  <DeliveryDiningIcon/>

                </SvgIcon>
              </IconButton>
            </Tooltip>
            <Tooltip title="Update Business Location">
              <IconButton
                onClick={() => {
                  navigate('/app/management/update/business/location', { state: params.row });
                }
                }
              >
                <SvgIcon fontSize="small">
                     <UpdateIcon />
                </SvgIcon>
              </IconButton>
            </Tooltip>
            <Tooltip title="Upload QR Code">
              <IconButton
                onClick={() => handleQrClick(params.row.customerId)}
              >
             <SvgIcon fontSize="small">
              <QrCodeIcon />
             </SvgIcon>
             </IconButton>
             </Tooltip>
             <Tooltip title="APK Availability">
  <IconButton
    onClick={() => handleApkAvailability(params.row)}
  >
    <SvgIcon fontSize="small">
      <PhoneAndroidIcon />
    </SvgIcon>
  </IconButton>
</Tooltip>
            <m>

            </m>
          </div>
        );
      },
    },
    { field: 'whatsApp', headerName: 'whatsApp', width: 150 },

    { field: 'registeredEmail', headerName: 'registeredEmail', width: 200 },
    { field: 'about', headerName: 'about', width: 200 },
    { field: 'mobile', headerName: 'Mobile', width: 100 },
    { field: 'GSTN', headerName: 'GSTN', width: 100 },
    { field: 'paymentGateway', headerName: 'paymentGateway', width: 200 },
    // { field: 'brandDetails', headerName: 'brandDetails', width: 100 },
    // { field: 'privacyPolicy', headerName: 'privacyPolicy', width: 100 },
    // { field: 'profileImage', headerName: 'ProfileImage', width: 100 },
  ]

return (
  <>
    <input
      type="file"
      accept="image/*"
      ref={fileInputRef}
      style={{ display: "none" }}
      onChange={handleQrUpload}
    />



<Box sx={{ height: 500, width: '100%' }}>
  <DataGrid
    rows={rows}
    columns={columns}
    getRowId={(row) => row.customerId}
    pageSize={10}
    rowsPerPageOptions={[10]}
  />
</Box>
<Dialog
  open={openPreview}
  onClose={() => setOpenPreview(false)}
  fullScreen
  hideBackdrop
  sx={{
    "& .MuiDialog-paper": {
      backgroundColor: "transparent",
      boxShadow: "none"
    }
  }}
>
  <DialogContent
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "80vh"
    }}
  >
    {previewImage ? (
      <img
        src={previewImage}
        alt="QR Preview"
        style={{
          width: "90vw",
          maxWidth: "500px",
          height: "auto",
          aspectRatio: "1 / 1",
          objectFit: "contain"
        }}
      />
    ) : (
      <Box sx={{ height: "500px" }} />
    )}
  </DialogContent>

  <DialogActions
    sx={{
      flexDirection: "column",
      alignItems: "center",
      pb: 4
    }}
  >
    {/* MESSAGE */}
    <Box
      sx={{
        fontWeight: 600,
        fontSize: "16px",
        mb: 2,
        color: qrMessageType === "success" ? "#2e7d32" : "#d32f2f"
      }}
    >
      {qrMessage}
    </Box>

    {/* BUTTONS */}
    <Box sx={{ display: "flex", gap: 2 }}>
      <Button
        variant="outlined"
        color="error"
        onClick={() => setOpenPreview(false)}
      >
        Cancel
      </Button>

<Button
  variant="contained"
  onClick={handleFinalUpload}
  disabled={!isValidQR}
>
  Upload QR Code
</Button>

    </Box>
  </DialogActions>
</Dialog>
<Dialog
  open={openApkDialog}
  onClose={() => setOpenApkDialog(false)}
>
  <DialogTitle>APK Availability</DialogTitle>

  <DialogContent>
  <FormControlLabel
    control={
        <Switch
            checked={apkData.isAndroid}
            onChange={(e) =>
                setApkData({
                    ...apkData,
                    isAndroid: e.target.checked
                })
            }
        />
    }
    label="Android"
/>

<FormControlLabel
    control={
        <Switch
            checked={apkData.isIos}
            onChange={(e) =>
                setApkData({
                    ...apkData,
                    isIos: e.target.checked
                })
            }
        />
    }
    label="iOS"
/>

<FormControlLabel
    control={
        <Switch
            checked={apkData.isWebApp}
            onChange={(e) =>
                setApkData({
                    ...apkData,
                    isWebApp: e.target.checked
                })
            }
        />
    }
    label="Web App"
/>

<FormControlLabel
    control={
        <Switch
            checked={apkData.isPosApp}
            onChange={(e) =>
                setApkData({
                    ...apkData,
                    isPosApp: e.target.checked
                })
            }
        />
    }
    label="POS App"
/>

  </DialogContent>
  <DialogActions>
    <Button
      onClick={() => setOpenApkDialog(false)}
    >
      Cancel
    </Button>
    <Button
      variant="contained"
      onClick={handleApkSave}
    >
      Save
    </Button>
  </DialogActions>
</Dialog>
  </>
);
}

Results.propTypes = {
  className: PropTypes.string,
  services: PropTypes.array
};

Results.defaultProps = {
  services: []
};

export default Results;



















